import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { getPriceFromMap } from './priceMapParser.js';

const selectOfferSelector = state =>
  state.get('customizeOfferSelector', initialState);

const makeSelectOfferSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('offer'),
  );

const makeSelectMonthlyRateSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('monthlyRate'),
  );

const makeSelectFeesVisibileSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('feesVisible'),
  );

const makeSelectFeesSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('fees'),
  );

const makeSelectDisplayOffers = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('display'),
  );
const makeSelectServicesSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('services'),
  );
const makeSelectAccessoriesSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('accessories'),
  );
const makeSelectColorsSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('colors'),
  );
const makeSelectAccessoriesCodesSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('accessoriesCodes'),
  );
const makeSelectColorCodesSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('colorCodes'),
  );

const getServicePriceByOfferParams = (service, selectedOffer) => {
  let { price } = service;

  if (service.has_price_map && service.price_map && (service, selectedOffer)) {
    const priceMapped = getPriceFromMap(price, service.price_map, selectedOffer);

    if (priceMapped) {
      price = priceMapped;
    }
  }

  return price;
}

export {
  selectOfferSelector,
  makeSelectMonthlyRateSelector,
  makeSelectOfferSelector,
  makeSelectDisplayOffers,
  makeSelectServicesSelector,
  makeSelectAccessoriesSelector,
  makeSelectColorsSelector,
  makeSelectAccessoriesCodesSelector,
  makeSelectColorCodesSelector,
  makeSelectFeesVisibileSelector,
  makeSelectFeesSelector,
  getServicePriceByOfferParams,
};
